import React, { useEffect, useState } from "react";
import NormalInput from "component/common/NormalInput";
import ErrorMessage from "component/common/ErrroMessage";
import { useForm } from "react-hook-form";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import usePopup from "hooks/usePopUp";

import styles from "./styles.module.scss";
import { Toast } from "utils/toast";
import Popup from "component/common/Popup/Popup";
import close_icon from "../../../assets/images/close_icon.png";
import NormalOutlineButton from "component/common/NormalOutlineButton";
import { getDisputeById, updateDispute } from "service/Disputed";
import moment from "moment";

const AddUpi = ({
  getSellerListData,
  addupi,
  showModalData,
  editUpi,
  viewPage,
  id,
  setEditModal,
}) => {
  const { successPopUp } = usePopup();

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();

  const showModalUPI = () => {
    showModalData(true);
  };

  const handleCancel = () => {
    showModalData(false);
    setEditModal(false);
    // resetFormDetails();
  };
  const [upiProduct, setUpiProduct] = useState({
    UPICode: "",
  });

  const [upiProductList, setUpiProductList] = useState({
    UPICodeList: [],
  });
  const [isAddClicked, setIsAddClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  // get seller
  const getDisputeDetails = async () => {
    if (id) {
      try {
        let response = await getDisputeById(id);
        if (response.status == 200) {
          const {
            UPICode,
            total_amount,
            note_for_issue,
            buyerName,
            buyerInstaHandle,
            sellerId_by_user,
            discount_amount,
            bankDetails,
            sale_date,
          } = response.data.data;
          setValue("total_amount", total_amount);
          setValue("discount_amount", discount_amount);
          setValue("note_for_issue", note_for_issue);
          setValue("buyerName", buyerName);
          setValue("buyerInstaHandle", buyerInstaHandle);
          setValue("sellerId_by_user", sellerId_by_user);
          setValue("ifscCode", bankDetails?.ifscCode);
          setValue("bankName", bankDetails?.bankName);
          setValue("accountHolderName", bankDetails?.accountHolderName);
          setValue("accountNumber", bankDetails?.accountNumber);
          setValue(
            "sale_date",
            moment(sale_date, "YYYY-MM-DD").format("YYYY-MM-DD")
          );
          setUpiProductList({
            UPICodeList: UPICode.map((x) => x?.upi),
          });
          setUpiProduct({
            UPICode: "",
          });
        }
      } catch (error) {
        // Toast({ type: "error", message: error.data.message });
      }
    }
  };

  // isEdit
  const onSubmit = async (data) => {
    console.log(data, "data");
    if(isAddClicked){
    let body = {
      ...data,
      UPICode: upiProductList.UPICodeList.map((data) => {
        return { upi: data };
      }),
    };

    try {
      body.buyerId = id;
      console.log(body, "bodyID");

      let response = await updateDispute(body);
      if (response) {
        Toast({ type: "success", message: "Successfully updated" });
        handleCancel();
        getSellerListData();
        setIsError(false); // Clear error state upon success

      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
      setIsError(true);

    }


  }else {
      setIsError(true);
      Toast({ type: "error", message: "Please add UPI ID before saving" });

    }
  };

  const resetFormDetails = () => {
    setUpiProductList({ UPICodeList: [] });
    setUpiProduct({ UPICode: "" });
  };

  // change Input values for seller and upi
  const handleChange = ({ name, value }) => {
    setUpiProductList(prevState => ({
      ...prevState,
      [name]: value,
    }));
    setUpiProduct({
      [name]: value,
    });

  };

  const addListOfRecords = (name) => {
    let UPIValidation = /^[\w.-]+@[\w.-]+$/.test(upiProduct[name]);
    let dataList = upiProductList;
    console.log(dataList, "dataList");
    let findDuplicate = dataList[name + "List"].indexOf(upiProduct[name]);
    if (findDuplicate === -1) {
      if (name === "UPICode" && UPIValidation) {
        dataList[name + "List"].push(upiProduct[name]);
        setUpiProductList({ ...dataList });
        setUpiProduct({
          [name]: "",
        });
        setValue(name, "");
        setIsAddClicked(true);
        setIsError(false);
      }
      if (name === "sellerProduct" && upiProduct[name] !== "") {
        dataList[name + "List"].push(upiProduct[name]);
        setUpiProductList({ ...dataList });
        setUpiProduct({
          [name]: "",
        });
        setValue(name, "");
        setIsAddClicked(true);
        setIsError(false);
      }
    } else {
      Toast({ type: "error", message: "Already exists" });
    }
    if (!UPIValidation && name === "UPICode" && upiProduct[name] !== "") {
      Toast({ type: "error", message: "Please enter valid UPI ID" });
    }
  };

  const deleteList = (val, listName) => {
    setIsAddClicked(true);

    let dataList = upiProductList;
    dataList[listName] = dataList[listName].filter((x) => x !== val);
    setUpiProductList({ ...dataList });
  };

  useEffect(() => {
    // if (editUpi && addupi) {
    getDisputeDetails();
  }, []);

  useEffect(() => {
    resetFormDetails();
  }, []);

  const { UPICodeList } = upiProductList;
  const { UPICode } = upiProduct;

  return (
    <>
      {!viewPage && (
        <NormalOutlineButton label="Add UPI" onClick={showModalUPI} />
      )}

      <Popup isOpen={addupi} setPopup={() => handleCancel()}>
        <div className={styles.sell_product_form}>
          <div className={styles.sell_form_title}>
            <span>ADD UPI</span>
            <div className={styles.blank} />
          </div>
          <div className="row">
            <div className="col">
              <NormalInput
                label="Seller UPI ID"
                placeholder="Enter UPI ID"
                register={register("UPICode", {
                  required: UPICodeList?.length > 0 ? false : true,
                })}
                error={errors.UPICode}
                onChange={handleChange}
                value={UPICode}
              />
              <ErrorMessage
                error={errors.UPICode}
                message={{
                  required: "Please enter seller UPI ID",
                }}
              />
            </div>
            <div className="col-md-6 d-flex align-items-end">
              <button
                className={styles.addButton}
                onClick={() => addListOfRecords("UPICode")}
              >
                ADD
              </button>
            </div>
            {UPICodeList?.length > 0 && (
              <div className="col-md-12 d-flex flex-wrap">
                {UPICodeList.map((val) => {
                  return (
                    <div className={styles.list_card_seller}>
                      {val}
                      <img
                        src={close_icon}
                        alt="Close Icon"
                        onClick={() => deleteList(val, "UPICodeList")}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <SaveCancelBtn
          position="center"
          onCancel={() => handleCancel()}
          onSave={handleSubmit(onSubmit)}
        />
        {successPopUp()}
      </Popup>
    </>
  );
};

export default AddUpi;
